const CROSSHAIR_ID = "dog-crosshair-overlay";

export function ensureCrosshairOverlay() {
    let crosshairEl = document.getElementById(CROSSHAIR_ID);
    if (crosshairEl) return crosshairEl;

    crosshairEl = document.createElement("div");
    crosshairEl.id = CROSSHAIR_ID;
    Object.assign(crosshairEl.style, {
        position: "fixed",
        left: "0px",
        top: "0px",
        width: "16px",
        height: "16px",
        pointerEvents: "none",
        zIndex: "2147483647",
        transform: "translate(-50%, -50%)",
        display: "none",
    });

    const crosshairBarStyle = {
        position: "absolute",
        left: "50%",
        top: "50%",
        background: "rgb(0, 255, 80)",
        boxShadow: "0 0 6px rgba(0, 255, 80, 0.8)",
        transform: "translate(-50%, -50%)",
    };

    const crosshairHorizontal = document.createElement("div");
    Object.assign(crosshairHorizontal.style, crosshairBarStyle, {
        width: "14px",
        height: "2px",
    });

    const crosshairVertical = document.createElement("div");
    Object.assign(crosshairVertical.style, crosshairBarStyle, {
        width: "2px",
        height: "14px",
    });

    crosshairEl.append(crosshairHorizontal, crosshairVertical);
    document.body.appendChild(crosshairEl);
    return crosshairEl;
}

export function showCrosshairAt(screenPos) {
    const crosshairEl = ensureCrosshairOverlay();
    crosshairEl.style.display = "block";
    crosshairEl.style.left = `${screenPos.x}px`;
    crosshairEl.style.top = `${screenPos.y}px`;
}

export function hideCrosshairOverlay() {
    const crosshairEl = document.getElementById(CROSSHAIR_ID);
    if (crosshairEl) crosshairEl.style.display = "none";
}

export function removeCrosshairOverlay() {
    document.getElementById(CROSSHAIR_ID)?.remove();
}
